import script from "./OperatorApplicationFreeDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationFreeDialog.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationFreeDialog.vue?vue&type=style&index=0&id=a980c35e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a980c35e"]])

export default __exports__